import { z } from 'zod';
import { UnauthedAccessRequestSchema } from '../schemas/prospectApiRequestSchemas';

export type UnauthedAccessRequest = z.input<typeof UnauthedAccessRequestSchema>
